
import { AbstractTracker } from './AbstractTracker';

/**
 * The [[AaasContentFormatTracker]] is an event-driven wrapper around tracking the progress of the alternative format
 * generation for Ally as a Service content Process. When created, the tracker will begin tracking progress immediately,
 * emitting a `progress` event on each polling interval. If it fails, an 'error' event is emitted. On success, a
 * 'finished' event is emitted.
 *
 * @param {String} statusUrl The URL where the Aaas content format status can be polled at
 * @param {String} token The token that can be used to poll the status endpoint
 */
export function AaasContentFormatTracker(statusUrl, token) {
    this.interval = 1000;
    this.statusUrl = statusUrl;
    this.token = token;

    // Begin tracking immediately
    this._poll();
}

AaasContentFormatTracker.prototype = Object.create(AbstractTracker.prototype);
AaasContentFormatTracker.prototype.constructor = AaasContentFormatTracker;
AaasContentFormatTracker.prototype.url = function() {
    return this.statusUrl;
};
AaasContentFormatTracker.prototype.states = function() {
    return {
        'failed': 'failed',
        'success': 'success'
    };
};
AaasContentFormatTracker.prototype.headers = function() {
    return {
        'Authorization': `Bearer ${this.token}`
    };
};
